import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatusViewProps } from "../../../../types";

export const getTaxVerificationRequirementPayerStatusCell = (
  requirement: IRequirementResponse
): RequirementStatusViewProps => {
  switch (requirement.status) {
    case RequirementStatus.Complete:
      return {
        pill: {
          text: "Complete",
          theme: "success",
          icon: true
        }
      };
    case RequirementStatus.PendingReview:
      return {
        pill: {
          theme: "warning",
          text: "Pending",
          icon: true
        }
      };
    default:
      return {
        pill: {
          theme: "warning",
          text: "Action required",
          icon: true
        }
      };
  }
};
